// Racine des endpoints SSO du back : le front n'appelle que GET {root}/{provider}/start
// (navigation top-level), le reste du flux est géré côté serveur (cf. ssoUtil.getSsoLoginUrl)
export const DEV_SSO_ROOT = 'http://localhost:8080/api/sso';
export const STAGING_SSO_ROOT = 'https://passfnacdarty.htmal1.com/api/sso';
export const PROD_SSO_ROOT = 'https://www.passfnacdarty.com/api/sso';



// WEBPACK FOOTER //
// ./src/constants/sso.js